import React from "react";
import { STATUS_DOT_COLORS } from "./Filters/PageToolbarFilters";

/**
 * Maps solid dot bg classes to their 10% opacity halo (must be literal strings for Tailwind JIT).
 * Dynamic `${solid}/10` is NOT scanned — Library Requests statuses like Released/Pending would miss the halo.
 */
const DOT_HALO_BY_SOLID_CLASS = {
  "bg-blue-600": "bg-blue-600/10",
  "bg-gray-400": "bg-gray-400/10",
  "bg-yellow-400": "bg-yellow-400/10",
  "bg-purple-400": "bg-purple-400/10",
  "bg-green-400": "bg-green-400/10",
  "bg-red-500": "bg-red-500/10",
  "bg-orange-500": "bg-orange-500/10",
  "bg-red-600": "bg-red-600/10",
  "bg-slate-400": "bg-slate-400/10",
  "bg-emerald-500": "bg-emerald-500/10",
  "bg-amber-400": "bg-amber-400/10",
  "bg-blue-500": "bg-blue-500/10",
};

/**
 * Status column cell: label with a small dot and a soft tinted halo (Innovation Lab pattern).
 * Matches `StatusIndicator` assessment styling and My Documents status rows.
 */
export default function GridStatusDotCell({ status }) {
  const dotColor = STATUS_DOT_COLORS[status] || "bg-gray-400";
  const haloClass =
    DOT_HALO_BY_SOLID_CLASS[dotColor] || "bg-gray-400/10";
  return (
    <div className="flex min-w-0 items-center gap-2">
      <div className={`flex-none rounded-full p-1 ${haloClass}`}>
        <div className={`h-2 w-2 rounded-full ${dotColor}`} />
      </div>
      <span className="truncate text-gray-500">{status || "--"}</span>
    </div>
  );
}
